import axios from '@/plugins/axios'
import { Module } from 'vuex'

export interface Post {
    username: string
    token: string
}

const reportKeywordModule: Module<any, any> = {
    state: {
        reportKeywords: [],
        totalRows: 0,
    },

    actions: {

        async getReportKeywords({ commit }, params) {

            const page = params?.page ?? 1
            const perPage = params?.perPage ?? 20

            let url = `/api/report_keywords?itemPerPage=${perPage}&page=${page}`

            url += params?.reportId ? `&reportId=${params.reportId}` : ''
            if (params?.dateStats) {
                url += params.dateStats.from
                    ? `&stats[from]=${params.dateStats.from}`
                    : ''
                url += params.dateStats.to
                    ? `&stats[to]=${params.dateStats.to}`
                    : ''
            }
            url += params?.workspaceMemberId ? `&workspaceMemberId=${params.workspaceMemberId}` : ''
            url += params?.profileUuid ? `&profileUuid=${params.profileUuid}` : ''
            url += params?.workspaceMemberIds ? `&workspaceMemberIds=${params.workspaceMemberIds}` : ''
            url += params?.profileUuids ? `&profileUuids=${params.profileUuids}` : ''            
            url += params?.sort ? `&sort=${params.sort}` : ''
            url += params?.order ? `&order=${params.order}` : ''
  
            const { data } = await axios.get(url)

            // commit('setPosts', data ? data['hydra:member'] : null)
            // commit('setTotalRows', data ? data['hydra:totalItems'] : 0)

            return data
        },

    },

    mutations: {
        setReportKeywords(state: any, reportKeywords) {
            state.reportKeywords = reportKeywords
        },
        setTotalRows(state: any, rows: number) {
            state.totalRows = rows
        },
    },
}

export default reportKeywordModule
